export enum CompanyEnum {
    Tot = 1,
    Teach = 2
}